module.exports = __webpack_public_path__ + "static/media/how_ru.3e743c44.vtt";